import { Button } from "@mui/material";
import React from "react";

const DashTabs = (props) => {
    const {show,setShow,setView,setUpdateData} = props
  return (
    <div className="Dash-table mt-4" style={{ height: "50px" }}>
      <div>
          <div
            style={{
              display: "flex",
              justifyContent:"end",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              id="btn"
              style={{ padding: show ? "10px" : "10px" }}
              onClick={() => {
                setShow(!show);
                setUpdateData([])
                // setView(false)
              }}
            >
                
              {show ? "x  Close" : "+ Add Consultant"}{" "}
            </Button>
          </div>
      </div>
    </div>
  );
};

export default DashTabs;
